import { Typography } from "@material-ui/core";

export function BulletItem({ text, classes }: { text: string; classes: any }) {
  return (
    <div className={classes.infoRow}>
      <div className={classes.infoBullet} />
      <Typography className={classes.infoText}>{text}</Typography>
    </div>
  );
}